import { NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "Dashboard", icon: "📊" },
  { to: "/analytics", label: "Analytics", icon: "📈" },
  { to: "/attribution", label: "Attribution", icon: "🎯" },
  { to: "/prompts", label: "Prompts", icon: "💬" },
  { to: "/models", label: "Models", icon: "🤖" },
  { to: "/billing", label: "Billing Health", icon: "💳" },
  { to: "/users", label: "Users", icon: "👥" },
  { to: "/mail-triage", label: "Mail Triage", icon: "📬" },
  { to: "/campaigns", label: "Campaigns", icon: "📣" },
  { to: "/brand-health", label: "Brand Health", icon: "🩺" },
];

interface NavSidebarProps {
  /** Whether the off-canvas drawer is slid on-screen (mobile only — `md:`
   * and up the sidebar is always visible, this prop is only consulted
   * below that breakpoint). */
  open: boolean;
  /** Called on backdrop click and on every nav-link click, so picking a
   * page also closes the drawer instead of leaving it covering the page
   * the operator just navigated to. */
  onClose: () => void;
}

/**
 * V2M-DEV-610: this used to be a permanently-visible 256px column, which on
 * a 390px phone left ~134px for the entire rest of the app — unusable. It is
 * now an off-canvas drawer below `md` (768px), toggled from Header's
 * hamburger button (`onMenuClick`/`open` wired through `App.tsx`), and the
 * same always-visible static column at `md:` and above — unchanged desktop
 * behaviour.
 */
export function NavSidebar({ open, onClose }: NavSidebarProps) {
  return (
    <>
      {open && (
        <div
          className="fixed inset-0 bg-slate-900/50 z-30 md:hidden"
          data-testid="nav-backdrop"
          onClick={onClose}
          aria-hidden="true"
        />
      )}
      <nav
        className={`fixed inset-y-0 left-0 z-40 w-64 bg-slate-900 flex flex-col transform transition-transform duration-200 ease-in-out md:static md:z-auto md:translate-x-0 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="p-6 border-b border-slate-800 shrink-0">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">V2M</span>
            </div>
            <span className="text-white font-semibold">Admin Panel</span>
          </div>
        </div>
        <div className="flex-1 p-4 space-y-1 overflow-y-auto">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-slate-800 text-white"
                    : "text-slate-400 hover:text-white hover:bg-slate-800/50"
                }`
              }
            >
              <span className="text-lg">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
}
